export default __webpack_public_path__ + "static/media/img-logo-mysql.5ad7f256.svg";